import { useMutation } from '@tanstack/react-query'
import { generateCsv } from '../../../../apis/prescription'

/**
 * CSV生成（レセコン送信）Mutation hook
 *
 * 処方箋IDを指定してCSVを生成し、レセコンに送信する。
 */
export const useGenerateCsvMutation = () => {
  return useMutation({
    mutationFn: (prescId: string) => generateCsv(prescId),
  })
}
